import React from 'react';
import PropTypes from 'prop-types';
import JourneyStatsCoins from '../../../journey/overall/stats/JourneyStatsCoins';

export default function JourneyBannerCoins({ coins }) {
  return (
    <div className="journey-overall-stats" style={{ display: 'flex' }}>
      {!!coins.wallet && (
        <JourneyStatsCoins
          value={coins.wallet}
          titleClass="text-dynamic"
          icon={
            <img
              style={{ marginRight: 0 }}
              src="/images/landing/coins_wallet.svg"
              alt="coins"
            />
          }
        />
      )}
      {!!coins.charity && (
        <JourneyStatsCoins
          value={coins.charity}
          titleClass="text-info"
          icon={
            <img
              style={{ marginRight: 0 }}
              src="/images/landing/coins_charity.svg"
              alt="coins to be donated"
            />
          }
        />
      )}
    </div>
  );
}

JourneyBannerCoins.propTypes = {
  coins: PropTypes.shape({ wallet: PropTypes.number.isRequired, charity: PropTypes.number }).isRequired,
}
